import "@fontsource-variable/inter/wght.css";
import "@fontsource-variable/playfair-display/wght.css";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

createRoot(document.getElementById("root")!).render(<App />);
